<template>
  <Multiselector
    v-if="options.length"
    v-bind="$attrs"
    :id="getRandomId('districts-select')"
    :model-value="selectedValues"
    :options="options"
    :placeholder="$t('Choose')"
    :main-input-label="$t('District')"
    :multiple="multiple"
    @update:model-value="onChange"
  />
</template>

<script>
import { useTrackFormLoading } from "@/components/newUi/core/useFormLoading";
import Multiselector from "@/components/Multiselector.vue";
import { getRandomId } from "@/utils/string";

export default {
  name: "DistrictsSelect",

  components: {
    Multiselector,
  },

  props: {
    modelValue: {
      type: [Number, Array],
      default: null,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    defaultOptions: {
      type: [Array, null],
      default: null,
    },
  },

  emits: ["update:modelValue"],

  setup() {
    return { trackFormLoading: useTrackFormLoading() };
  },

  data() {
    return {
      allOptions: [],
    };
  },

  computed: {
    selectedValues() {
      return this.modelValue ? (this.multiple ? this.modelValue : [this.modelValue]) : [];
    },

    options() {
      return this.defaultOptions || this.allOptions;
    },
  },

  async mounted() {
    this.allOptions =
      this.defaultOptions ||
      (await this.trackFormLoading(this.$store.dispatch("districts/getOptions")));
  },

  methods: {
    getRandomId,

    onChange(values) {
      if (!this.multiple && Array.isArray(values)) {
        values = values[0];
      }

      this.$emit("update:modelValue", values);
    },
  },
};
</script>
